import React from 'react'
// styles
import './OnlineUsers.css'
// hooks
import { useCollection } from '../../Hooks/useCollection'
// components
import Avatar from '../avator/Avatar'
export default function OnlineUsers() {
    const { document, error } = useCollection('users')

    return (
        <div className='user-list'>
            <h2>All users</h2>
            { error && <div className='error'>{error}</div>}
            {document && document.map(user => (
                <div key={user.id} className='user-list-item'>
                    <Avatar image={user.photoURL}/>
                    <span>{user.displayName}</span>
                    {user.online && <span className="online-user"></span>}
                </div>
            ))}
        </div>
    )
}
